<template>
  <div
    class="app"
    :key="state.lang"
    :class="{
      english: state.lang == 'en',
      persian: state.lang == 'fa',
      home: $route.name === 'home',
    }"
    :dir="$isRTL() ? 'rtl' : 'ltr'"
  >
    <PublicNavbar v-if="!$route.path.includes('Panel')" />
    <LoadingPage v-if="state.loading" />
    <router-view></router-view>
  </div>
</template>

<script>
import PublicNavbar from "./components/Public/PublicNavbar";
import LoadingPage from "./components/Tools/LoadingPage";
export default {
  name: "App",
  components: {
    PublicNavbar,
    LoadingPage,
  },
  mounted() {
    window.addEventListener("storage", (event) => {
      console.log(event);
    });
  },
};
</script>

<style lang="scss">
.app {
  background: rgba(2, 14, 56, 1);
  min-height: 100vh;
  flex-direction: column;
  display: flex;
  width: 100%;
  align-items: center;
}
</style>
<style lang="scss">
.home {
  .c-qllnV .raychat_sc_launcher {
    width: 163px !important;
    height: 57px !important;
    background-color: var(--primary-color) !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    position: fixed !important;
    right: var(--widget-right-position) !important;
    left: var(--widget-left-position) !important;
    bottom: var(--widget-bottom-position) !important;
    top: var(--widget-top-position) !important;
    border-radius: 16px !important;
    box-shadow: none !important;
    transition: box-shadow 0.2s ease-in-out 0s !important;
    z-index: 2147483647 !important;
    overflow: hidden !important;
    display: none;
    opacity: 0;
  }
}
</style>
